import React from 'react';
import { policeEffectiveDate } from '../utils/date';
import BaseDateField from './BaseDateField';

const EffectiveDate = props => {
  return <BaseDateField {...props} validationFn={policeEffectiveDate} />;
};

export default EffectiveDate;
